import { getTimestampByDaysAgo, normalizeDateRange } from "lib/dates";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import { ApyPeriod } from "lib/oracleKeeperFetcher";

export const POOLS_TIME_RANGE_OPTIONS = ["24h", "7d", "14d", "30d", "total"] as const;

export type PoolsTimeRange = (typeof POOLS_TIME_RANGE_OPTIONS)[number];

export type Period = {
  periodStart: number;
  periodEnd: number;
};

export function usePoolsTimeRange() {
  const [timeRange, setTimeRange] = useLocalStorageSerializeKey<PoolsTimeRange>("pools-time-range", "24h");
  const isValidTimeRange = timeRange && POOLS_TIME_RANGE_OPTIONS.includes(timeRange);
  return { timeRange: isValidTimeRange ? timeRange : "24h", setTimeRange };
}

function getStartDate(days: number) {
  return new Date(getTimestampByDaysAgo(days) * 1000);
}

const TIME_RANGE_TO_DAYS = {
  total: new Date(0),
  "24h": getStartDate(1),
  "7d": getStartDate(7),
  "14d": getStartDate(14),
  "30d": getStartDate(30),
} as const;

export function convertPoolsTimeRangeToPeriod(timeRange: PoolsTimeRange): Period {
  const [periodStart, periodEnd] = normalizeDateRange(
    TIME_RANGE_TO_DAYS[timeRange] ?? TIME_RANGE_TO_DAYS["24h"],
    new Date()
  );
  return {
    periodStart: Math.max(periodStart, 0),
    periodEnd: Math.min(periodEnd, Date.now()),
  };
}

export const convertPoolsTimeRangeToApyPeriod = (timeRange: PoolsTimeRange): ApyPeriod => {
  switch (timeRange) {
    case "total":
      return "total";
    case "24h":
      return "1d";
    case "7d":
      return "7d";
    case "14d":
      return "7d";
    case "30d":
      return "30d";
    default:
      return "7d";
  }
};
